import React from 'react';
import { TopBarContextType } from './types';

const TopBarContext = React.createContext<TopBarContextType | undefined>(
  undefined,
);

export default TopBarContext;
